import { showToast, hideToast } from './toast.js';
import Choices from "choices.js";

import "choices.js/public/assets/styles/choices.min.css";

const bottomBtns = document.querySelector(".bottom-btns");
const addBtns = document.querySelectorAll(".add-parcelle");

// const parcellesWrapper = form?.querySelector(".parcelle__wrapper");

const forms = document.querySelectorAll("#form-map-edit, #form-map-new");

addBtns?.forEach(btn => {
    btn.addEventListener("click", function () {
        // Trouver le formulaire parent du bouton cliqué
        const form = btn.closest("form");

        if (!form) return;

        const parcellesWrapper = form.querySelector(".parcelle__wrapper");
        const parcelles = form.querySelectorAll("[id^='wrapper-parcelle-']");
        const last = parcelles[parcelles.length - 1];
        const newIndex = parcelles.length;

        // Clone la dernière parcelle
        const clone = last.cloneNode(true);
        clone.id = `wrapper-parcelle-${newIndex}`;

        // Remplace les index [x] dans les name et id
        clone.querySelectorAll("[name], [id], [for]").forEach((el) => {
            if (el.name) el.name = el.name.replace(/\[\d+\]/, `[${newIndex}]`);
            if (el.id) el.id = el.id.replace(/-\d+(-|$)/, `-${newIndex}$1`);
            if (el.htmlFor) el.htmlFor = el.htmlFor.replace(/-\d+(-|$)/, `-${newIndex}$1`);
        });

        // Vider les champs
        clone.querySelectorAll("input, textarea").forEach((el) => {
            if (el.type === "radio" || el.type === "checkbox") {
                el.checked = false;
            } else {
                el.value = "";
            }
        });

        clone.querySelectorAll("input[type='radio']").forEach((radio) => {
            const name = radio.name;
            // Trouver tous les radios avec ce même nom dans le clone
            const radiosInGroup = clone.querySelectorAll(`input[type='radio'][name='${name}']`);
            if (radiosInGroup.length > 0) {
                radiosInGroup[0].checked = true;
            }
        });

        // Ajouter au formulaire
        // parcellesWrapper.insertBefore(clone, bottomBtns);
        last.insertAdjacentElement('afterend', clone);

        // Animation d'apparition
        clone.classList.add("parcelle-enter");
        void clone.offsetWidth; // force reflow
        clone.classList.add("parcelle-enter-active");

        // Nettoyer les classes après la transition
        clone.addEventListener("transitionend", () => {
            clone.classList.remove("parcelle-enter");
            clone.classList.remove("parcelle-enter-active");
        }, { once: true });
    });
});

// Gestion suppression
// form?.addEventListener("click", function (e) {
//     if (e.target.classList.contains("remove-parcelle")) {
//         // hideToast('danger')
//         const parcelles = Array.from(parcellesWrapper.children).filter(el => el.id?.startsWith("wrapper-parcelle-"));

//         if (parcelles.length <= 1) {
//             alert("Attention, il doit rester au moins une parcelle.");
//             return;
//         }

//         const bloc = e.target.closest("[id^='wrapper-parcelle-']");
//         if (bloc) {
//             // Ajouter la classe d'animation de sortie
//             bloc.classList.add("parcelle-exit");
//             void bloc.offsetWidth; // force reflow
//             bloc.classList.add("parcelle-exit-active");

//             // Après la transition, supprimer l'élément du DOM
//             bloc.addEventListener("transitionend", () => {
//                 bloc.remove();
//             }, { once: true });
//         }
//     }
// });

forms.forEach(form => {
    form.addEventListener("click", function (e) {
        if (e.target.classList.contains("remove-parcelle")) {
            const parcellesWrapper = form.querySelector(".parcelle__wrapper");

            const parcelles = Array.from(parcellesWrapper.children).filter(el => el.id?.startsWith("wrapper-parcelle-"));

            if (parcelles.length <= 1) {
                alert("Attention, il doit rester au moins une parcelle.");
                return;
            }

            const bloc = e.target.closest("[id^='wrapper-parcelle-']");
            if (bloc) {
                bloc.classList.add("parcelle-exit");
                void bloc.offsetWidth; // force reflow
                bloc.classList.add("parcelle-exit-active");

                bloc.addEventListener("transitionend", () => {
                    bloc.remove();
                }, { once: true });
            }
        }
    });
});








const formEdit = document.getElementById("form-map-edit");

formEdit?.addEventListener('submit', async (e) => {
    e.preventDefault();

    // Validation du champ notaire obligatoire
    const notaireSelect = formEdit.querySelector('#notaire');
    if (notaireSelect && !notaireSelect.value) {
        showToast('danger', 'Veuillez sélectionner un notaire avant de sauvegarder.');
        // Focus sur le champ pour aider l'utilisateur
        notaireSelect.focus();
        return;
    }

    const spinner = document.querySelector('.load-spinner');
    spinner?.classList.remove('hidden');

    const formData = new FormData(formEdit);


    try {
        const response = await fetch(WPData.ajaxUrl, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) throw new Error(`Erreur : ${response.status}`);

        const data = await response.json();
        // console.log(data);

        if (data.success) {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            showToast('success', data.data.message);
        } else {
            showToast('danger', data.data.message || 'Une erreur est survenue.');
        }
    } catch (error) {
        console.error('Erreur AJAX :', error);
        showToast('danger', 'Erreur lors de l’envoi du formulaire.');
    } finally {
        spinner?.classList.add('hidden');
    }
});

const formCreate = document.getElementById("form-map-new");
formCreate?.addEventListener('submit', async (e) => {
    // Validation du champ notaire obligatoire pour le formulaire de création
    const notaireSelect = formCreate?.querySelector('#notaire');
    if (notaireSelect && !notaireSelect.value) {
        e.preventDefault();
        showToast('danger', 'Veuillez sélectionner un notaire avant de créer le dossier.');
        notaireSelect.focus();
        return;
    }

    const spinner = document.querySelector('.load-spinner');
    spinner?.classList.remove('hidden');
});

const element = document.querySelector("#colabos");

if (element) {
    const choices = new Choices(element, {
        searchEnabled: true,
        itemSelectText: "✔",
        removeItemButton: true,
        placeholder: true,
        placeholderValue: "Sélectionner des collaborateurs",
    });
}